import { render, staticRenderFns } from "./loginAlert.vue?vue&type=template&id=46a5d5b0&scoped=true&"
import script from "./loginAlert.vue?vue&type=script&lang=js&"
export * from "./loginAlert.vue?vue&type=script&lang=js&"
import style0 from "./loginAlert.vue?vue&type=style&index=0&id=46a5d5b0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5d5b0",
  null
  
)

export default component.exports